/**
 * Enlaces y textos legales compartidos LP Hispano Medical Plan 2027.
 */

export const HMP_PRESENTATION_PDF =
  'https://drive.google.com/file/d/1XTASIAQQivJovubkSPuTw-gu980GzTyy/view?usp=sharing'

export const HMP_LEGAL_DISCLAIMER =
  'Hispano Medical Plan es una membresía médica, no es un seguro médico. No cubre hospitalización, emergencias ni cirugías y no cumple con requisitos de cobertura mínima esencial. Precios y beneficios sujetos a cambio. Los ejemplos de ingresos son ilustrativos y no garantizan resultados.'
